'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.atomicMoveAndUpdate = exports.updateSelectedElements = exports.updateMultipleElements = exports.updateElement = exports.unshareElement = exports.shareElement = exports.createAndSelectElement = exports.loadElements = exports.createElement = exports.setElementType = exports.createElementWithId = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _elementActions = require('../../common/elements/elementActions');

Object.defineProperty(exports, 'createElementWithId', {
    enumerable: true,
    get: function get() {
        return _elementActions.createElementWithId;
    }
});
Object.defineProperty(exports, 'setElementType', {
    enumerable: true,
    get: function get() {
        return _elementActions.setElementType;
    }
});

var _lodash = require('lodash');

var _createElementId = require('../../common/uid/createElementId');

var _createElementId2 = _interopRequireDefault(_createElementId);

var _inboxActions = require('../inbox/inboxActions');

var _elementAttachmentActions = require('./elementAttachmentActions');

var _selectionActions = require('./selection/selectionActions');

var _elementHelper = require('../../common/elements/elementHelper');

var _timeUtil = require('../../common/utils/timeUtil');

var _undoRedoTransactionManager = require('../utils/undoRedo/undoRedoTransactionManager');

var _selectedElementsSelector = require('./selection/selectedElementsSelector');

var _elementMoveActions = require('./elementMoveActions');

var _elementConstants = require('../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _elementsConstants = require('../../common/elements/elementsConstants');

var ELEMENTS_ACTION_TYPE = _interopRequireWildcard(_elementsConstants);

var _imageConstants = require('../../common/images/imageConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Util


/**
 * Creates an element in the given location with the provided content.
 * If the location is a list but it doesn't have a score associated to it, the score will be calculated and the item
 * will be inserted at that location.
 *
 * @param elementType {String} The type of the element to create (BOARD | CARD, etc).
 * @param location {Object} An object containing the parentId, section and position.
 * @param content {Object} An object representing the content of the element.
 * @param sync {boolean} [true] Whether to sync this action with the server or not.
 */
var createElement = exports.createElement = function createElement(action) {
    return function (dispatch, getState) {
        var elementType = action.elementType,
            location = action.location,
            content = action.content,
            attachment = action.attachment,
            _action$sync = action.sync,
            sync = _action$sync === undefined ? true : _action$sync,
            duplicate = action.duplicate;


        var state = getState();
        var currentUser = state.getIn(['app', 'currentUser']);
        var userId = currentUser.get('_id');
        var clientId = currentUser.get('clientId');
        var clientTick = currentUser.get('clientTick');
        var elementId = (0, _createElementId2.default)(clientId, clientTick);
        var now = (0, _timeUtil.getTimestamp)();
        var transactionId = action.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();

        // Use the element move utility function to calculate the score
        var creates = [{ id: elementId, location: location }];
        creates.map((0, _elementMoveActions.updateLocation)(dispatch, getState)(creates));
        var updatedLocation = creates[0] && creates[0].location || location;

        dispatch((0, _elementActions.createElementWithId)({
            id: elementId,
            elementType: elementType,
            location: updatedLocation,
            content: content,
            sync: sync,
            modified: now,
            meta: {
                creator: userId
            },
            transactionId: transactionId,
            duplicate: duplicate
        }));

        dispatch((0, _inboxActions.setInboxFromElementCreate)({ location: location, transactionId: transactionId }));

        if (attachment) {
            dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: elementId, file: attachment, transactionId: transactionId }));
        }

        return elementId;
    };
};

var loadElements = exports.loadElements = function loadElements(elements, deletedElementIds) {
    return {
        type: ELEMENTS_ACTION_TYPE.ELEMENTS_LOAD,
        elements: elements,
        deletedElementIds: deletedElementIds
    };
};

var createAndSelectElement = exports.createAndSelectElement = function createAndSelectElement(action) {
    return function (dispatch, getState) {
        action.transactionId = action.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();
        var transactionId = action.transactionId;

        var elementId = dispatch(createElement(action));

        // can't select an element that doesn't exist
        var elements = getState().get('elements');
        var createdElement = elements.get(elementId);
        if (!createdElement) return elementId;

        if (action.currentBoardId && action.location.parentId !== action.currentBoardId) {
            var targetElementType = elements.getIn([action.location.parentId, 'elementType']);

            // Don't select or start editing the element if it's dropped into a board
            if ((0, _elementHelper.isBoardLike)(targetElementType)) return elementId;
        }

        dispatch((0, _selectionActions.setSelectedElements)({ ids: [elementId], transactionId: transactionId }));

        // Don't start editing images otherwise captions cannot be written straight away
        if (action.elementType === _imageConstants.IMAGE_TYPE) return elementId;

        (0, _lodash.defer)(function () {
            return dispatch((0, _selectionActions.startEditingElement)({ id: elementId, editorKey: action.elementType, transactionId: transactionId }));
        });

        return elementId;
    };
};

var shareElement = exports.shareElement = function shareElement(_ref) {
    var id = _ref.id,
        userId = _ref.userId,
        permissions = _ref.permissions,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync;
    return {
        type: TYPES.ELEMENT_SHARE,
        id: id,
        userId: userId,
        permissions: permissions,
        modified: (0, _timeUtil.getTimestamp)(),
        sync: sync
    };
};

var unshareElement = exports.unshareElement = function unshareElement(_ref2) {
    var id = _ref2.id,
        userId = _ref2.userId,
        _ref2$sync = _ref2.sync,
        sync = _ref2$sync === undefined ? true : _ref2$sync;
    return {
        type: TYPES.ELEMENT_UNSHARE,
        id: id,
        userId: userId,
        modified: (0, _timeUtil.getTimestamp)(),
        sync: sync
    };
};

var updateElement = function updateElement(_ref3) {
    var _ref3$transactionId = _ref3.transactionId,
        transactionId = _ref3$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref3$transactionId,
        rest = _objectWithoutProperties(_ref3, ['transactionId']);

    return (0, _elementActions.updateElement)(_extends({}, rest, {
        transactionId: transactionId
    }));
};

exports.updateElement = updateElement;
var updateMultipleElements = function updateMultipleElements(_ref4) {
    var _ref4$transactionId = _ref4.transactionId,
        transactionId = _ref4$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref4$transactionId,
        rest = _objectWithoutProperties(_ref4, ['transactionId']);

    return (0, _elementActions.updateMultipleElements)(_extends({}, rest, {
        transactionId: transactionId
    }));
};

exports.updateMultipleElements = updateMultipleElements;
var defaultPredicate = function defaultPredicate() {
    return true;
};

var updateSelectedElements = function updateSelectedElements(_ref5) {
    var changes = _ref5.changes,
        _ref5$predicate = _ref5.predicate,
        predicate = _ref5$predicate === undefined ? defaultPredicate : _ref5$predicate,
        rest = _objectWithoutProperties(_ref5, ['changes', 'predicate']);

    return function (dispatch, getState) {
        var state = getState();
        var elementsToUpdate = (0, _selectedElementsSelector.getSelectedElements)(state).filter(predicate);
        var updates = elementsToUpdate.map(function (element) {
            return { id: element.get('id'), changes: changes };
        }).toJS();
        return dispatch(updateMultipleElements(_extends({ updates: updates }, rest)));
    };
};

exports.updateSelectedElements = updateSelectedElements;
var getSimpleMoveData = function getSimpleMoveData(_ref6) {
    var id = _ref6.id,
        location = _ref6.location,
        getState = _ref6.getState;

    // Get the element's current location, this will be the 'from' location in the action
    var state = getState();
    var element = state.getIn(['elements', id]);
    var from = element.get('location').toJS();

    return {
        id: id,
        location: location,
        from: from
    };
};

var atomicMoveAndUpdate = exports.atomicMoveAndUpdate = function atomicMoveAndUpdate(_ref7) {
    var id = _ref7.id,
        location = _ref7.location,
        changes = _ref7.changes,
        _ref7$sync = _ref7.sync,
        sync = _ref7$sync === undefined ? true : _ref7$sync,
        _ref7$transactionId = _ref7.transactionId,
        transactionId = _ref7$transactionId === undefined ? (0, _undoRedoTransactionManager.getNewTransactionId)() : _ref7$transactionId;
    return function (dispatch, getState) {
        return dispatch(_extends({
            type: TYPES.ELEMENT_MOVE_AND_UPDATE
        }, getSimpleMoveData({ id: id, location: location, getState: getState }), {
            changes: changes,
            sync: sync,
            modified: (0, _timeUtil.getTimestamp)(),
            transactionId: transactionId
        }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementActions.js
// module id = 26
// module chunks = 0